// Frozen-quarter audit history view.
import React from 'react';
import { moneyFull } from '../../lib/api';
import { STATUS_COLORS } from './_shared';

export function HistoryView({ data }) {
  const history = data?.history || [];
  const kpis = data?.kpis || {};

  if (history.length === 0) {
    return (
      <div className="bg-white border-t-4 border-indie-navy p-8 text-center">
        <div className="text-sm text-indie-ink/65">
          No past audits frozen yet. Once you complete a quarter's audit and click "Freeze quarter snapshot," it'll appear here.
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <div className="bg-white border-t-4 border-indie-evergreen p-5">
        <div className="label-editorial">Realized savings · annualized</div>
        <div className="text-3xl font-bold text-indie-evergreen mt-1 num-tabular">{moneyFull(kpis.realized_savings_total_annualized)}</div>
        <p className="text-xs text-indie-ink/65 mt-2">
          Sum of $/mo impact across all Cut + Renegotiate decisions in frozen quarter snapshots, annualized.
        </p>
      </div>

      <div className="space-y-3">
        {history.map((snap) => (
          <div key={snap.id} className="bg-white border-l-4 border-indie-navy p-4">
            <div className="flex items-baseline justify-between gap-3 mb-2">
              <div>
                <div className="text-lg font-bold text-indie-navy">{snap.quarter_key}</div>
                <div className="text-xs text-indie-ink/55">
                  Frozen {new Date(snap.frozen_at).toLocaleDateString()} by {snap.frozen_by_name}
                </div>
              </div>
              <div className="text-right">
                <div className="text-xs text-indie-ink/55">Monthly savings est.</div>
                <div className="font-semibold text-indie-evergreen num-tabular">{moneyFull(snap.total_monthly_savings_estimate)}</div>
              </div>
            </div>
            <div className="text-xs text-indie-ink/65 mb-2">
              {snap.vendor_count} vendors · {snap.decisions?.length || 0} decisions logged
            </div>
            <details>
              <summary className="text-xs text-indie-cobalt cursor-pointer hover:text-indie-navy">View decisions</summary>
              <div className="mt-2 space-y-1 text-sm">
                {snap.decisions?.map((d, i) => {
                  const palette = STATUS_COLORS[d.decision] || STATUS_COLORS.Watch;
                  return (
                    <div key={i} className="flex items-baseline justify-between gap-3 border-b border-indie-navy/5 py-1">
                      <span className="font-semibold text-indie-navy truncate">{d.vendor_name}</span>
                      <span className="flex items-center gap-2">
                        <span className={`inline-flex items-center gap-1 px-1.5 text-[10px] uppercase tracking-wider font-semibold ${palette.bg} ${palette.text}`}>
                          {d.decision}
                        </span>
                        <span className="num-tabular text-indie-ink/75">{moneyFull(d.dollar_impact)}/mo</span>
                      </span>
                    </div>
                  );
                })}
              </div>
            </details>
          </div>
        ))}
      </div>
    </div>
  );
}
